import { jsx as s } from "react/jsx-runtime";
import { Label as m } from "../../Label/Label.js";
import { fieldHelperTextVariants as a } from "./FieldHelperText.variants.js";
const n = ({
  className: e,
  isDisabled: r,
  ...o
}) => {
  const { root: t } = a;
  return /* @__PURE__ */ s(
    m,
    {
      as: "span",
      className: t({ className: e, isDisabled: r }),
      size: "sm",
      ...o
    }
  );
};
export {
  n as FieldHelperText
};
